import { render } from "./avatar-color-carousel-selector.vue?vue&type=template&id=67282ad4"
import script from "./avatar-color-carousel-selector.vue?vue&type=script&lang=js"
export * from "./avatar-color-carousel-selector.vue?vue&type=script&lang=js"

import "./avatar-color-carousel-selector.vue?vue&type=style&index=0&id=67282ad4&lang=css"

import exportComponent from "F:\\DEV\\estimationpoker\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__